(function($) {

    $(document).on( 'click', '.accordion-toggler', function() {

        if ($(this).next().hasClass('open')) {
            $(this).next().removeClass('open');
            $(this).find('img').removeClass('down');
        } else {
            $(this).next().addClass('open');
            $(this).find('img').addClass('down');
        }

    });


    $(document).on( 'click', '#shipping-to-other', function() {

        $('#shipping-to-billing').prop('checked', false);

        $('.shipping .woocommerce-shipping-fields').addClass('open');
        $('.shipping').find('img').removeClass('down');
        $( "#ship-to-different-address-checkbox" ).trigger( "click" );

    });

    $(document).on( 'click', '#shipping-to-billing', function() {

        $('#shipping-to-other').prop('checked', false);
        
        $('.shipping .woocommerce-shipping-fields').removeClass('open');
        $('.shipping').find('img').removeClass('down');
        $( "#ship-to-different-address-checkbox" ).trigger( "click" );

    });


})
(jQuery);
